// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__5iMjJ","right":"styles_right__1UXGU"};